import { render } from "./PriceTemplatesIndexPage.vue?vue&type=template&id=0a45e04f&scoped=true"
import script from "./PriceTemplatesIndexPage.vue?vue&type=script&lang=js"
export * from "./PriceTemplatesIndexPage.vue?vue&type=script&lang=js"

import "./PriceTemplatesIndexPage.vue?vue&type=style&index=0&id=0a45e04f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a45e04f"]])

export default __exports__